import { Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { Link } from 'react-router';
import { crmWidgetAmountFormat } from './presentation';
import type { DealStatusAmounts as StatusAmounts } from './reportTypes';

interface DealStatusAmountsProps {
  items: StatusAmounts;
  getStatusUrl: (statusId: number) => string;
}

/** Суммы по статусам с переходом к соответствующей выборке сделок. */
export function DealStatusAmounts({ items, getStatusUrl }: DealStatusAmountsProps) {
  return (
    <Group gap='xl' wrap='nowrap'>
      {items.map(item => (
        <UnstyledButton
          key={item.id}
          component={Link}
          to={getStatusUrl(item.id)}
          style={{
            flex: 1,
            minWidth: 0,
            backgroundColor: 'var(--mantine-color-default-hover)',
            padding: '6px 8px',
            borderRadius: 8,
          }}
        >
          <Stack gap={0}>
            <Text size='xs' c='dimmed'>
              {item.name}
            </Text>
            <Text size='sm' fw={600}>
              {crmWidgetAmountFormat.format(item.total)} ₽
            </Text>
          </Stack>
        </UnstyledButton>
      ))}
    </Group>
  );
}
